import DirectCallLandingView from "../components/landing/directCall/DirectCallLandingView";

const LandingDirectCall1 = () => (
  <DirectCallLandingView
    landingName="landing-direct-call-1"
    phoneDisplay="02 4074 1077"
    phoneTel="tel:+390240741077"
  />
);

export default LandingDirectCall1;
